export default __webpack_public_path__ + "static/media/art-pro-slt-2.43553839.png";